import React, { useState, useRef, useEffect } from "react";
import Header from "./Header";
import { useDispatch, useSelector } from "react-redux";
import {
  AdminProfile,
  DirectorProfile,
  EmployeeProfile,
  HodProfile,
  ImageUpload,
  IndentProfile,
  StoreInchargeProfile,
  SystemAdminProfile,
  UpdateAdminProfile,
  UpdateDirectorProfile,
  UpdateEmployeeProfile,
  UpdateHodProfile,
  UpdateIndentProfile,
  UpdateStoreInchargeProfile,
  UpdateSystemAdminProfile,
} from "../Repository/Api";
import { updateSpecificUserDetailsKeyinState } from "../Store/auth/action";
import moment from "moment";
import { GetInitials } from "../Store/constants";
import { errorMsg, successMsg } from "./Toastify";
import { PhoneNumberValidation } from "../Store/validate";
import { imagepath } from "../Repository/BaseUrl";
const Profile = () => {
  const state = useSelector((state) => state);
  const token = state?.auth?.auth?.access_token;
  const dispatch = useDispatch();
  const ProfileRef = useRef();

  useEffect(() => {
    getProfile();
  },[]);

  const [profile, setProfile] = useState({});
  
  const [validation, setValidation] = useState({});

  const setData = (e, key) => {
    setProfile({ ...profile, [key]: e });
    if (validation[key]) setValidation({ ...validation, [key]: false });
  };

  const getProfile = async () => {
    const userTypesToProfileFunctions = {
      employee: EmployeeProfile,
      hod: HodProfile,
      admin: AdminProfile,
      director: DirectorProfile,
      system_admin: SystemAdminProfile,
      indent: IndentProfile,
      store_incharge: StoreInchargeProfile,
    };

    const userType = state?.auth?.auth?.user_type_value;
    const profileFunction = userTypesToProfileFunctions[userType];

    if (!profileFunction) {
      errorMsg("Invalid user type");
      return;
    }

    try {
      const response = await profileFunction(token);
      if (response && response.statusCode === 200) {
        setProfile(response?.data);
      } else {
        errorMsg(response.message);
      }
    } catch (error) {
      errorMsg("An error occurred while fetching the profile.");
    }
  };
  const updateProfile = async (e) => {
    e.preventDefault();

    let validate = {};
    validate.phone_number = PhoneNumberValidation(profile?.phone_number);

    const Payload = {
      phone_number: profile?.phone_number,
      profile_image: profile?.profile_image,
    };

    const userTypesToUpdate = {
      employee: UpdateEmployeeProfile,
      hod: UpdateHodProfile,
      admin: UpdateAdminProfile,
      director: UpdateDirectorProfile,
      system_admin: UpdateSystemAdminProfile,
      indent: UpdateIndentProfile,
      store_incharge: UpdateStoreInchargeProfile,
    };

    const userType = state?.auth?.auth?.user_type_value;

    if (userTypesToUpdate.hasOwnProperty(userType)) {
      const updateFunction = userTypesToUpdate[userType];
      try {
        const response = await updateFunction(Payload, token);
        if (response && response.statusCode === 200) {
          successMsg(response.message);
        } else {
          errorMsg(response.message);
        }
      } catch (error) {
        errorMsg("An error occurred while updating the profile.");
      }
    } else {
      errorMsg("Invalid user type");
    }
  };

  // const [data, setimgData] = useState([]);
  // const imageData = (formData, image, size, height, width) => {
  //   return { formData: formData, image: image, size: size, height: height, width: width }
  // }

  const UploadDocument = async (e, key) => {
    const file = e.target.files[0];
    const imagekey = key
    const image = e.target?.files[0]
    const imgsize = (image.size / 1024)
    const maxSizeInBytes = 500 * 1024;
    if (file.size > maxSizeInBytes) {
      errorMsg("File size exceeds the limit of 500KB");
      return;
    }

    let formData = new FormData();
    let str = file.name;
    formData.append("file", file);
    formData.append("fileName", moment().format("YYYYMMDDHHmmss") + "_" + str);
    formData.append("file_path", "/profile_image");
    // const reader = new FileReader
    // reader.onload = async (e) => {
    //   const img = new Image();
    //   img.src = e.target.result;
    //   img.onload = () => {
    //     setimgData([
    //       imageData(formData, imagekey, imgsize, img.height, img.width)
    //     ])
    //   }
    // };
    // reader.readAsDataURL(image)
    
    const response = await ImageUpload(formData);
    
    if (response && response.statusCode === 200) {
      setData(response.data, key);
      successMsg(response.message);
    } else {
      errorMsg(response.message);
    }
  };

  // const ImageUploadin = async () => {
  //   
  //   if (data?.length > 0) {
  //     const dummy = data[0]
  //     
  //     if (dummy?.image === "profile_image" && dummy?.size <= 200 && dummy?.height >= 100 && dummy?.width >= 100) {
  //       
  //       const response = await ImageUpload(dummy?.formData);
  //       
  //       if (response && response.statusCode === 200) {
  //         setData(response.data, "profile_image");
  //         successMsg(response.message);
  //       } else {
  //         errorMsg(response.message);
  //       }
  //     }
  //     else {
  //       
  //       errorMsg("The image should fit the recommended file size.")
  //     }
  //   }
  // }

  // useEffect(() => {
  //   if (data) {
  //     ImageUploadin()
  //   }
  // }, [data])

  const handleRemoveProfile = async () => {
    const payload = {
      profile_image: "",
    };

    const userTypesToUpdate = {
      employee: UpdateEmployeeProfile,
      hod: UpdateHodProfile,
      admin: UpdateAdminProfile,
      director: UpdateDirectorProfile,
      system_admin: UpdateSystemAdminProfile,
      indent: UpdateIndentProfile,
      store_incharge: UpdateStoreInchargeProfile,
    };

    const userType = state?.auth?.auth?.user_type_value;
    const updateFunction = userTypesToUpdate[userType];

    if (!updateFunction) {
      errorMsg("Invalid user type");
      return;
    }

    try {
      const response = await updateFunction(payload, token);

      if (response && response.statusCode === 200) {
        dispatch(updateSpecificUserDetailsKeyinState(response.data));
        getProfile();
        successMsg(response.message);
      } else {
        errorMsg(response.message);
      }
    } catch (error) {
      errorMsg("An error occurred while handling the profile removal.");
    }
  };

  return (
    <>
      <div className="">
        <section className="top-content-container">
          <div className="my-4">
            <div className="row">
              <div className="col-lg-6">
                <h6 className="headertext">My Profile</h6>
              </div>
            </div>
          </div>
        </section>
        <section className="profile-bg-content">
          <div className="row">
            <div className="col-lg-3">
              <div className="profilesection1-content mt-5">
                <div className="position-relative m-auto d-flex align-items-center justify-content-center">
                  <div className="progress-profile mb-2">
                    <span>
                      {!profile?.profile_image ? (
                        <div className="messageimagelettercircle">
                          {GetInitials(profile?.first_name)}
                        </div>
                      ) : null}
                      <img
                        className="userprofilecircle w-100"
                        src={`${imagepath}${profile?.profile_image}`}
                        alt=""
                        hidden={!profile?.profile_image}
                      />
                    </span>
                  </div>
                  {!profile?.profile_image ? (
                    <span
                      className="material-symbols-rounded addpic"
                      onClick={() => ProfileRef.current.click()}
                    >
                      add_a_photo
                      <input
                        autoComplete="off"
                        type="file"
                        name="myfile"
                        ref={ProfileRef}
                        hidden
                        onChange={(e) => UploadDocument(e, "profile_image")}
                        accept="image/jpeg, image/png"
                      />
                    </span>
                  ) : (
                    <span
                      className="material-symbols-rounded removepic"
                      onClick={() => handleRemoveProfile()}
                    >
                      cancel
                    </span>
                  )}
                </div>
                <small className="image-info">Image upload : Max 200kb min 100px X 100px</small>
              </div>
            </div>
            <div className="col-lg-9">
              <form onSubmit={(e) => updateProfile(e)}>
                {state?.auth?.auth?.user_type_value === "employee" ? (
                  <div className="my-5 px-3">
                    <div className="row justify-content-between mt-2">
                      <div className="col-lg-6">
                        <div className="">
                          <label className="labeltext">First Name</label>
                          <input
                            type="text"
                            className="fieldinput"
                            autoComplete="off"
                            value={profile?.first_name}
                            disabled
                          />
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="">
                          <label className="labeltext">Last Name</label>
                          <input
                            type="text"
                            className="fieldinput"
                            autoComplete="off"
                            value={profile?.last_name}
                            disabled
                          />
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="">
                          <label className="labeltext">Phone No</label>
                          <input
                            type="text"
                            className="fieldinput"
                            placeholder="Enter Phone Mobile"
                            autoComplete="off"
                            maxLength={10}
                            value={profile?.phone_number}
                            onChange={(e) =>
                              setData(e.target.value, "phone_number")
                            }
                          />
                          <small className="validationerror">
                            {validation?.phone_number?.message
                              ? `Phone Number ${validation?.phone_number?.message}`
                              : ""}
                          </small>
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="">
                          <label className="labeltext">Gender</label>
                          <input
                            type="text"
                            className="fieldinput"
                            autoComplete="off"
                            value={profile?.gender}
                            disabled
                          />
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="">
                          <label className="labeltext">Email ID</label>
                          <input
                            type="text"
                            className="fieldinput"
                            autoComplete="off"
                            value={profile?.email_id}
                            disabled
                          />
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="">
                          <label className="labeltext">Department</label>
                          <input
                            type="text"
                            className="fieldinput"
                            autoComplete="off"
                            value={profile?.department}
                            disabled
                          />
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="">
                          <label className="labeltext">Designation</label>
                          <input
                            type="text"
                            className="fieldinput"
                            autoComplete="off"
                            value={profile?.designation}
                            disabled
                          />
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="">
                          <label className="labeltext">Date Of Birth</label>
                          <input
                            type="text"
                            className="fieldinput"
                            autoComplete="off"
                            value={moment(profile?.dob).format("DD-MM-yyyy")}
                            disabled
                          />
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="">
                          <label className="labeltext">Date Of Joining</label>
                          <input
                            type="text"
                            className="fieldinput"
                            autoComplete="off"
                            value={moment(profile?.doj).format("DD-MM-yyyy")}
                            disabled
                          />
                        </div>
                      </div>
                      <div className="col-lg-12 mt-5">
                        <div className="d-flex justify-content-center">
                          <button className="requestbtn">Update</button>
                        </div>
                      </div>
                    </div>
                  </div>
                ) : (
                  ""
                )}
                {state?.auth?.auth?.user_type_value === "hod" ||
                  state?.auth?.auth?.user_type_value === "admin" ||
                  state?.auth?.auth?.user_type_value === "director" ||
                  state?.auth?.auth?.user_type_value === "system_admin" ||
                  state?.auth?.auth?.user_type_value === "store_incharge" ? (
                  <div className="my-5 px-3">
                    <div className="row justify-content-between mt-2">
                      <div className="col-lg-6">
                        <div className="">
                          <label className="labeltext">First Name</label>
                          <input
                            type="text"
                            className="fieldinput"
                            autoComplete="off"
                            value={profile?.first_name}
                            disabled
                          />
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="">
                          <label className="labeltext">Last Name</label>
                          <input
                            type="text"
                            className="fieldinput"
                            autoComplete="off"
                            value={profile?.last_name}
                            disabled
                          />
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="">
                          <label className="labeltext">Phone No</label>
                          <input
                            type="text"
                            className="fieldinput"
                            placeholder="Enter Phone Mobile"
                            autoComplete="off"
                            maxLength={10}
                            value={profile?.phone_number}
                            onChange={(e) =>
                              setData(e.target.value, "phone_number")
                            }
                          />
                          <small className="validationerror">
                            {validation?.phone_number?.message
                              ? `Phone Number ${validation?.phone_number?.message}`
                              : ""}
                          </small>
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="">
                          <label className="labeltext">Email ID</label>
                          <input
                            type="text"
                            className="fieldinput"
                            autoComplete="off"
                            value={profile?.email_id}
                            disabled
                          />
                        </div>
                      </div>
                      {profile?.department ? (
                        <div className="col-lg-6">
                          <div className="">
                            <label className="labeltext">Department</label>
                            <input
                              type="text"
                              className="fieldinput"
                              autoComplete="off"
                              value={profile?.department}
                              disabled
                            />
                          </div>
                        </div>
                      ) : (
                        ""
                      )}
                      <div className="col-lg-12 mt-5">
                        <div className="d-flex justify-content-center">
                          <button className="requestbtn">Update</button>
                        </div>
                      </div>
                    </div>
                  </div>
                ) : (
                  ""
                )}
                {state?.auth?.auth?.user_type_value === "indent" ? (
                  <div className="my-5 px-3">
                    <div className="row justify-content-between mt-2">
                      <div className="col-lg-6">
                        <div className="">
                          <label className="labeltext">First Name</label>
                          <input
                            type="text"
                            className="fieldinput"
                            autoComplete="off"
                            value={profile?.first_name}
                            disabled
                          />
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="">
                          <label className="labeltext">Last Name</label>
                          <input
                            type="text"
                            className="fieldinput"
                            autoComplete="off"
                            value={profile?.last_name}
                            disabled
                          />
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="">
                          <label className="labeltext">Phone No</label>
                          <input
                            type="text"
                            className="fieldinput"
                            placeholder="Enter Phone Mobile"
                            autoComplete="off"
                            maxLength={10}
                            value={profile?.phone_number}
                            onChange={(e) =>
                              setData(e.target.value, "phone_number")
                            }
                          />
                          <small className="validationerror">
                            {validation?.phone_number?.message
                              ? `Phone Number ${validation?.phone_number?.message}`
                              : ""}
                          </small>
                        </div>
                      </div>
                      {profile?.department ? (
                        <div className="col-lg-6">
                          <div className="">
                            <label className="labeltext">Department</label>
                            <input
                              type="text"
                              className="fieldinput"
                              autoComplete="off"
                              value={profile?.department}
                              disabled
                            />
                          </div>
                        </div>
                      ) : (
                        ""
                      )}
                      <div className="col-lg-12 mt-5">
                        <div className="d-flex justify-content-center">
                          <button className="requestbtn">Update</button>
                        </div>
                      </div>
                    </div>
                  </div>
                ) : (
                  ""
                )}
              </form>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default Profile;
